import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading, ToastController, ViewController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import { EmailValidator } from '../../validators/email';
import { DateTimeAdapter } from 'ng-pick-datetime';
import * as moment from 'moment';

interface myInterface2 {
  id: string;
  creationDate: Date;
  description: string;
  files: any[];
  idAlumno: string;
  idCoach: string;
  name: string;
  sessionDate: Date;
  tasks: string[];
}

@IonicPage()
@Component({
  selector: 'page-user-update',
  templateUrl: 'user-update.html',
})
export class UserUpdatePage {
  public max = new Date();
  data: any;
  myForm: FormGroup;
  inputFile: any[] = [""];
  files: any[] = [];
  arrayFiles: any[] = [];
  loading: Loading;
  idItem: string = '';

  sessionDoc: AngularFirestoreDocument<myInterface2>;
  session: myInterface2;

  constructor(dateTimeAdapter: DateTimeAdapter<any>, public asf: AngularFirestore, public navCtrl: NavController, public navParams: NavParams, public formBuilder: FormBuilder, public toastCtrl: ToastController, public loadingCtrl: LoadingController, public viewCtrl: ViewController) {
    dateTimeAdapter.setLocale('es-ES'); // change locale to spanish
    this.data = this.navParams.get("item");
    this.idItem = this.data.id;
    this.myForm = this.formBuilder.group({
      name: [this.data && this.data.name ? this.data.name : '', Validators.required],
      sex: [this.data && this.data.sex ? this.data.sex : ''],
      email2: [this.data && this.data.email2 ? this.data.email2 : '', EmailValidator.isValid],
      dob: [this.data && this.data.dob ? moment(this.data.dob).format("YYYY-MM-DD") : ''],
      company: [this.data && this.data.company ? this.data.company : ''],
      ocupation: [this.data && this.data.ocupation ? this.data.ocupation : ''],
      phone: [this.data && this.data.phone ? this.data.phone : ''],
    });
  }

  guardar(item: any) {
    this.viewCtrl.dismiss({ type: 'updated', data: item });
  }

  ionViewDidLoad() { }

  onSubmit() {
    this.presentLoadingCustom();
    if (this.myForm.value.dob) {
      this.myForm.value.dob = moment(this.myForm.value.dob).format("YYYY-MM-DD");
    }
    let update = {
      company: this.myForm.value.company,
      dob: this.myForm.value.dob,
      email2: this.myForm.value.email2,
      name: this.myForm.value.name,
      uppercaseName : String(this.myForm.value.name).toLocaleUpperCase(),
      ocupation: this.myForm.value.ocupation,
      phone: this.myForm.value.phone,
      sex: this.myForm.value.sex,
    }
    this.asf.doc('Users/' + this.data.id).update(update).then(res => {
      this.asf.doc('Users/' + this.data.id).ref.get().then(data => {
        const ret = data.data();
        ret['id'] = data.id;
        this.loading.dismiss();
        this.presentToast("Usuario editado correctamente");
        this.guardar(ret);
      });

    }).catch(error => {
      this.loading.dismiss();
      ////console.error(error);
      this.presentToast(error);
    });
  }

  presentLoadingCustom() {
    this.loading = this.loadingCtrl.create({
      content: `Loading`
    });
    this.loading.present();
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  cancel() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/user-update/user-update.ts